import React from 'react';
import { Outlet, Route, Routes, Navigate } from 'react-router-dom';
import Layout from './ts/components/layout/Layout';
import Home from './ts/components/application/Home';
import TestSpc from './ts/components/application/TestPages/TestSpc';
import TestVsd from './ts/components/application/TestPages/TestVsd';
import TestClientDocument from './ts/components/application/TestPages/TestClientDocument';
import { nonProduction } from './ts/services';
import TestIpc from './ts/components/application/TestPages/TestIpc';

const routes = (
    <Routes>
        <Route path='/*' element={<Layout><Outlet /></Layout>}>
            <Route index element={<Navigate to='/testspc' replace />} />
            <Route path='debug' element={<Home debug />} />
            <Route path='testspc' element={<TestSpc />} />
            <Route path='testvsd' element={<TestVsd />} />
            <Route path='testipc' element={<TestIpc />} />
            <Route path='testclientdocument' element={<TestClientDocument />} />
            <Route path='spcRequest' element={<Home debug={nonProduction} spcRequest />} />
            <Route path='ipcRequest' element={<Home debug={nonProduction} ipcRequest />} />
            <Route path='results' element={<Home debug={nonProduction} />} />
            <Route path='*' element={<Home debug={nonProduction} />} />
        </Route>
    </Routes>
);

export default routes;
